import { render, staticRenderFns } from "./customMaterial.vue?vue&type=template&id=5b2769a5&scoped=true"
import script from "./customMaterial.vue?vue&type=script&lang=js"
export * from "./customMaterial.vue?vue&type=script&lang=js"
import style0 from "./customMaterial.vue?vue&type=style&index=0&id=5b2769a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2769a5",
  null
  
)

export default component.exports